import {ChangeEvent} from "react";
import {FavoriteProduct} from "../model/types";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

export const useFavorite = (product: FavoriteProduct) => {
    const {favouritesStore} = useStoreMobx();

    const checked = favouritesStore.favouritesData.some((item) => Number(item.id) === Number(product.id));
    const favoriteChange = (event: ChangeEvent<HTMLInputElement>) => favouritesStore.favouritesChange(event, product);

    return {
        checked,
        favoriteChange
    }
}
